function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M212.6-.2C185.2-.2 163 22 163 49.4V234c.4 27.4 22.9 49.3 50.3 49 26.8-.4 48.5-22.1 48.9-49V49.5c0-27.4-22.2-49.7-49.6-49.7zM233.9 234c0 11.8-9.5 21.3-21.3 21.3-11.7 0-21.3-9.5-21.3-21.3v-21.4h21.3v-14.2h-21.3V170h21.3v-14.2h-21.3v-28.4h21.3v-14.2h-21.3V84.9h21.3V70.7h-21.3V49.5c0-11.8 9.5-21.3 21.3-21.3 11.7 0 21.3 9.5 21.3 21.3V234zM127.6.2H99.2v49.4H63.8V.2H35.4v49.4H21.3v24.9c0 27.8 19 51.9 46.1 58.4v150.5h28.3V132.8c27-6.5 46.1-30.6 46.1-58.4V49.5h-14.2V.2z"
})));